import { render } from "./Main.vue?vue&type=template&id=af80757a&scoped=true"
import script from "./Main.vue?vue&type=script&lang=ts"
export * from "./Main.vue?vue&type=script&lang=ts"

import "./Main.vue?vue&type=style&index=0&id=af80757a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-af80757a"

export default script